export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_fees(state, {fees}) {
    state.fees = fees.data;
    state.totalCount = fees.total;
    state.count = fees.totalt;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
